module.exports = __webpack_public_path__ + "static/media/seattle.28817f93.jpeg";